import { z } from "zod";
import { isoDateTimeString, uuidSchema } from "./common";

// Mirror of Prisma enum InviteCreditLedgerReason.
export const creditLedgerReasonSchema = z.enum([
  "PURCHASE",
  "SIGNUP_BONUS",
  "KYC_BONUS",
  "INVITE_CLAIM_BONUS",
  "ADMIN_GRANT",
  "INVITE_SPENT",
  "INVITE_REFUNDED",
]);
export type CreditLedgerReason = z.infer<typeof creditLedgerReasonSchema>;

// One +/- change to the org's available interview-credit balance.
export const creditLedgerEntrySchema = z.object({
  id: uuidSchema,
  delta: z.number().int(),
  reason: creditLedgerReasonSchema,
  balanceAfter: z.number().int(),
  note: z.string().nullable(),
  createdAt: isoDateTimeString,
});
export type CreditLedgerEntry = z.infer<typeof creditLedgerEntrySchema>;

export const creditLedgerResponseSchema = z.object({
  items: z.array(creditLedgerEntrySchema),
});
export type CreditLedgerResponse = z.infer<typeof creditLedgerResponseSchema>;
